<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig.isLoading"
    (filterChange)="createTableData($event)"
></mt-filter>

<div
    class="report-container mt-4"
    *ngIf="hasData || tableConfig || message || systemError"
>
    <div class="header-container">
        <div class="header">
            <div class="float-left title">
                {{ "report-marine" | lang | uppercase }}
            </div>
            <div class="float-right" *ngIf="canDownload">
                <app-button-icon
                    [image]="'download'"
                    [iconType]="'icon'"
                    [disabled]="disabledExcelBtn"
                    [spinner]="btnSpinner"
                    (clickHandler)="downloadExcel()"
                ></app-button-icon>
            </div>
        </div>
    </div>
    <div [ngClass]="{ 'body-container': tableConfig }">
        <!-- Message -->
        <div class="d-flex flex-row message" *ngIf="message">
            <img
                class="message-img"
                appImageSelector
                [imageType]="'icon'"
                [imageKey]="'error-red'"
                alt="error"
            />
            <span class="message-text">{{ message }}</span>
        </div>
        <app-system-error-message
            *ngIf="!!systemError"
            [message]="systemError"
        ></app-system-error-message>

        <div [hidden]="hidden">
            <div class="row">
                <div class="col-6">
                    <!--Table ByShift-->
                    <app-details-table-marine
                        *ngIf="hasData"
                        [marineLoops]="reportData"
                    ></app-details-table-marine>
                </div>
                <div class="col-6">
                    <!--Table ByMachine-->
                    <app-main-table
                        *ngIf="tableByMachine"
                        [tableConfig]="tableByMachine"
                    ></app-main-table>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <!--Table Details Marine Report-->
                    <app-main-table
                        *ngIf="tableConfig"
                        [tableConfig]="tableConfig"
                    ></app-main-table>
                </div>
            </div>
        </div>
    </div>
</div>
